module.exports = __webpack_public_path__ + "img/low.4e0d66e6.svg";